import { apiGet, type RequestOptions } from '.'

export interface DashboardStatsResponse {
  unread_total: number
  messages_today: number
  new_prep_items_last_24_hours: number
  my_prep_count: number
}

export interface DashboardStatsPayload {
  unreadTotal: number
  messagesToday: number
  newPrepItemsLast24Hours: number
  myPrepCount: number
}

export async function getDashboardStats(
  stationId: number,
  options: RequestOptions = {},
): Promise<DashboardStatsPayload> {
  const search = new URLSearchParams()
  search.set('station_id', String(stationId))

  const response = await apiGet<DashboardStatsResponse>(
    `dashboard/stats?${search.toString()}`,
    options,
  )

  return {
    unreadTotal: response.unread_total,
    messagesToday: response.messages_today,
    newPrepItemsLast24Hours: response.new_prep_items_last_24_hours,
    myPrepCount: response.my_prep_count,
  }
}
